import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import Cookies from 'js-cookie'
import styled from 'styled-components'
import {
  makeStyles,
  withStyles,
  Grid,
  GridList,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Avatar,
  Typography,
  FormGroup,
  FormControlLabel,
  Switch,
  Checkbox,
  Button,
  Paper,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  InputBase,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  IconButton,
  Tooltip,
  Menu,
  Slide,
  Divider,
  ListItemText,
  ListItemIcon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core'
import { Pagination } from '@material-ui/lab'
import { Apps, Search, Replay, Edit, PersonAdd } from '@material-ui/icons'
import PageHeader from '../PageHeader'
import SvgIcon from '@material-ui/core/SvgIcon'
import { Link } from 'react-router-dom'
import {RiDeleteBin2Line, RiEditCircleLine, RiAddCircleFill, RiMore2Line, RiImageLine} from 'react-icons/ri'
import { TiDelete } from 'react-icons/ti'
import logo from '../../assets/SmartDash.png'

const base_url = 'https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm'

const useStyles = makeStyles(theme => ({
  pageTitle: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '18px',
    fontWeight: 'light',
    color: 'rgba(115, 115, 115, 0.9)'
  },
  pageIcon: {
    fontSize: '15px',
    color: 'rgba(115, 115, 115, 0.9)',
    marginTop: '5px',
    marginRight: '2px',
  },
  select: {
    color: 'rgba(115, 115, 115, 0.9)',
    marginTop: '14px',
    width: 200,
    '&:active': {
      color: '#000'
    }
  },
  selectIcon: {
    color: '#9e9e9e'
  },
  locationSelect: {
    color: 'rgba(115, 115, 115, 0.9)',
    marginRight: '15px',
    width: 300,
    '&:active': {
      color: '#000'
    }
  },
  buttonInclude: {
    color: '#00a323',
    borderColor: '#00a323',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#00a323'
    }
  },
  buttonIncludeActive: {
    color: '#fff',
    backgroundColor: '#00a323',
    '&:hover': {
      backgroundColor: '#00c72b'
    }
  },
  buttonExclude: {
    color: '#b8413f',
    borderColor: '#b8413f',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#b8413f'
    }
  },
  buttonExcludeActive: {
    color: '#fff',
    backgroundColor: '#b8413f',
    '&:hover': {
      backgroundColor: '#d96a68'
    }
  },
  buttonReset: {
    color: '#50a5bf',
    borderColor: '#50a5bf',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#50a5bf'
    }
  },
  buttonEdit: {
    color: '#50a5bf',
    borderColor: '#50a5bf',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#50a5bf'
    }
  },
  buttonEditActive: {
    color: '#fff',
    backgroundColor: '#50a5bf',
    '&:hover': {
      backgroundColor: '#79c2d9'
    }
  },
  header: {
    color: '#fff',
    borderLeft:  '1px solid #dcdbdc',
  },
  pagination: {
    '& .MuiPaginationItem-root': {
      color: '#fff',
    },
    '& .Mui-selected': {
      color: '#25aae1',
      border: '1px solid #25aae1 '
    }

  }
}))

function SalesConsultantIcon(props) {
  return(
    <SvgIcon {...props}>
      <path fill="currentColor" d="M2 3H22A2.07 2.07 0 0 1 24 5V19A2.07 2.07 0 0 1 22 21H2A2.07 2.07 0 0 1 0 19V5A2.07 2.07 0 0 1 2 3M8 13.91C6 13.91 2 15 2 17V18H14V17C14 15 10 13.91 8 13.91M8 6A3 3 0 1 0 11 9A3 3 0 0 0 8 6M17 10V13H21V10H17" />
    </SvgIcon>
  )
}

function AccountEditIcon(props) {
  return(
    <SvgIcon {...props}>
      <path fill="currentColor" d="M21.7,13.35L20.7,14.35L18.65,12.3L19.65,11.3C19.86,11.09 20.21,11.09 20.42,11.3L21.7,12.58C21.91,12.79 21.91,13.14 21.7,13.35M12,18.94L18.06,12.88L20.11,14.93L14.06,21H12V18.94M12,14C7.58,14 4,15.79 4,18V20H10V18.11L14,14.11C13.34,14.03 12.67,14 12,14M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4Z" />
    </SvgIcon>
  )
}

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 750
    },
  },
}

// const StyledTextField = styled(TextField)`
//   label.Mui-focused {
//     color: #1d3d74
//   }
//   .MuiOutlinedInput-root {
//     fieldset{
//       color: '#fff'
//     }
//     &.Mui-focused fieldset {
//       border-color: #1d3d74
//     }
//   }
// `

const StyledTextField = styled(TextField)({
  '& label': {
    color: '#fff',
  },
  '& label.Mui-focused': {
    color: '#18bdfe',
  },
  '& .MuiOutlinedInput-root': {
    color: '#fff',
    '&:hover fieldset': {
      borderColor: '#18bdfe',
    },
    '& fieldset': {
      color: '#fff',
      borderColor: '#fff'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#18bdfe',
      color: '#fff',
    },
  },
  '& .MuiOutlinedInput-input': {
    color: '#fff',
    backgroundColor: 'transparent',
    borderRadius: 4,
  }
})

const StyledSelect = withStyles((theme) => ({
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: 'transparent',
    color: '#fff',
    border: '1px solid #bfbfbf',
    fontSize: 16,
    padding: '17.5px 26px 17px 26px',
    '&:focus': {
      borderRadius: 4,
      borderColor: '#1d3d74'
    }
  }
}))(InputBase)

export default function SalesPersonsDirectory() {
  const classes = useStyles()
  const token = Cookies.get('token')
  const [salespersons, setSalesPersons] = useState(null)
  const [salespersonID, setSalespersonID] = useState(0)
  const [filteredsalespersons, setFilteredSalesPersons] = useState(null)
  const [locations, setLocations] = useState(null)
  const [locationID, setLocationID] = useState(null)
  const [inclusion, setInclusion] = useState(null)
  const [anchor, setAnchor] = useState(null)
  const [openOptions, setOpenOptions] = useState(false)
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const [rows, setRows] = useState(18)
  const [removeOpen, setRemoveOpen] = useState(false)

  const getSalesPersons = () => {
    const request = Promise.all([
      fetch(`${base_url}/salesperson`, {
        headers: {'token': token}
      }),
      fetch(`${base_url}/salesperson/locations`, {
        headers: {'token': token}
      })
    ])

    request
    .then(([response, response2]) => Promise.all([response.json(), response2.json()]))
    .then(([data, data2]) => {
      if(data) {
        console.log(data)
        setSalesPersons(data)
        setFilteredSalesPersons(data)
        setLocations(data2)
      } else {
        setSalesPersons([])
        setFilteredSalesPersons([])
        setLocations(data2)
      }
    })
    .catch(error => {console.log(error)})
  }

  useEffect(() => getSalesPersons(), [])

  const updateSearch = (e) => {
    const {value} = e.target

    if(value) setSearch(value)
    else setSearch('')
  }

  const handleLocationChange = (e) => {
    const { value } = e.target

    if(value !== 'location') {
      let location = salespersons.filter(({LocationID}) => LocationID === value)
      if(inclusion) {
        let inclusionStatus = location.filter(({InclusionStatus}) => InclusionStatus === inclusion)
        setFilteredSalesPersons(inclusionStatus)
        setLocationID(value)
      } else {
        setFilteredSalesPersons(location)
        setLocationID(value)
      }
    } else {
      if(inclusion) {
        let inclusionStatus = salespersons.filter(({InclusionStatus}) => InclusionStatus === value)
        setFilteredSalesPersons(inclusionStatus)
        setLocationID(null)
      } else {
        setFilteredSalesPersons(salespersons)
        setLocationID(null)
      }
    }
  }

  const handleInclusionStatus = (e, status) => {
    const { value } = e.target

    if(value !== 0) {
      let inclusionStatus = salespersons.filter(({InclusionStatus}) => InclusionStatus === value)
      if(locationID) {
        let filteredByLoc = inclusionStatus.filter(({LocationID}) => LocationID === locationID)
        setFilteredSalesPersons(filteredByLoc)
        setInclusion(value)
      } else {
        setFilteredSalesPersons(inclusionStatus)
        setInclusion(value)
      }
    } else {
      if(locationID) {
        let filteredByLoc = salespersons.filter(({LocationID}) => LocationID === locationID)
        setFilteredSalesPersons(filteredByLoc)
        setInclusion(null)
      } else {
        setFilteredSalesPersons(salespersons)
        setInclusion(null)
      }
    }
  }

  const handleChangePage = (e, newPage) => {
    setPage(newPage)
  }

  const handleOptionsOpen = (e, salesID) => {
    const {currentTarget} = e
    const selected = salespersons.filter(({Key}) => Key === salesID)[0].SalespersonID

    setAnchor(currentTarget)
    setOpenOptions(true)
    setSalespersonID(selected)
  }

  const handleOptionsClose = () => {
    setAnchor(null)
    setOpenOptions(false)
  }

  const handleRemovePerson = () => {
    const toRemove = salespersons.filter(({SalespersonID}) => SalespersonID === salespersonID)[0]
    toRemove['InclusionStatus'] = 3

    const request = fetch(`${base_url}/salesperson/update`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': Cookies.get('token'),
      },
      body: JSON.stringify(toRemove)
    })

    request.then(response => {
      if(response.ok === true) return response.json()
    })
    .then(data => {
      setRemoveOpen(false)
    })
    .catch(error => console.log(error))
  }

  const removePersonPrompt = (salesID) => {
    setRemoveOpen(true)
    handleOptionsClose()
  }

  const handleRemoveClose = () => {
    setRemoveOpen(false)
  }

  const RemoveDialog = () => {
    let selected = salespersonID ? salespersons.filter(({SalespersonID}) => SalespersonID === salespersonID)[0] : 0

    return (
      <Dialog
        open={removeOpen}
        onClose={handleRemoveClose}
        className="salespersons-dialog"
      >
        <DialogTitle style={{backgroundColor: '#e7e7e7', borderBottom: '1px solid #9e9e9e'}}>
        </DialogTitle>
        <DialogContent className="salespersons-dialog-content" style={{paddingTop: '35px'}}>
          <img src={logo} alt="" style={{height: 40}}/>
          <DialogContentText style={{marginLeft: '25px'}}>
            <Typography variant="caption">
              Are you sure you want to remove <span style={{fontSize: '15px', fontWeight: 'bold', color: 'grey'}}>{selected['FirstName'] + ' ' + selected['LastName']}</span> ?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="salespersons-dialog-action">
          <Button onClick={handleRemoveClose}>CANCEL</Button>
          <Button variant="contained" className="delete" style={{backgroundColor: '#c93f3c', color: '#fff'}} onClick={handleRemovePerson}>REMOVE</Button>
        </DialogActions>
      </Dialog>
    )
  }

  if(!filteredsalespersons || !locations) return <CircularProgress />

  const renderLocationOptions = () => (
    locations.map(({Address1, City, State, ZIP, Key, LocationID}, i) => (
      <MenuItem key={Key} value={LocationID}>{`${Address1}, ${City}, ${State}, ${ZIP}`}</MenuItem>
    ))
  )

  let filteredPersons = filteredsalespersons.filter(({FirstName, LastName}, i) => {
    return FirstName.toLowerCase().indexOf(search.toLowerCase()) !== -1 || LastName.toLowerCase().indexOf(search.toLowerCase()) !== -1
  })

  return(
    <div id="salespersons-category">
      <PageHeader details={{icon: <SalesConsultantIcon />, title: "New Movers - Featured Sales Consultants"}} />
      <div className="options">
        <div className="filter">
          <StyledTextField
            style={{margin: '1em', width: 225}}
            variant="outlined"
            label="Search By Name"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search style={{color: '#9e9e9e'}} fontSize="small" />
                </InputAdornment>
              )
            }}
            value={search}
            onChange={updateSearch}
          />
          <Select
            variant="outlined"
            input={<StyledSelect />}
            className="select"
            defaultValue={"location"}
            onChange={handleLocationChange}
            MenuProps={MenuProps}
            inputProps={{
              classes: {
                icon: classes.selectIcon
              }
            }}
          >
            <MenuItem value="location">All Locations</MenuItem>
            {renderLocationOptions()}
          </Select>
          <Select
            variant="outlined"
            input={<StyledSelect />}
            className="status-select"
            defaultValue={0}
            onChange={handleInclusionStatus}
            inputProps={{
              classes: {
                icon: classes.selectIcon
              }
            }}
          >
            <MenuItem value={0}>All Status</MenuItem>
            <MenuItem value={1}>Included</MenuItem>
            <MenuItem value={2}>Excluded</MenuItem>
          </Select>
        </div>
        <Tooltip title="Add A New Consultant">
          <IconButton href="/sales-consultants-add"><RiAddCircleFill className="sales-add-btn"/></IconButton>
        </Tooltip>
      </div>

      <Menu
        open={openOptions}
        anchorEl={anchor}
        onClose={handleOptionsClose}
        className="salespersons-menu"
      >
        {/* <MenuItem style={{backgroundColor: 'transparent'}}>
          <Typography variant="caption" className="menu-item edit">
            View Card Preview <RiImageLine className="menu-icon"/>
          </Typography>
        </MenuItem> */}
        <MenuItem style={{backgroundColor: 'transparent'}} onClick={handleOptionsClose}>
          <Typography variant="caption" className="menu-item edit" >
            <Link
              to={{
                pathname: `/sales-consultants/${salespersonID}`,
                state: {salespersonID: salespersonID}
              }}
              className="edit menu-item"
            >
              Edit Consultant
              <RiEditCircleLine className="menu-icon" />
            </Link>
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem style={{backgroundColor: 'transparent'}} onClick={() => removePersonPrompt(salespersonID)}><Typography variant="caption" className="menu-item delete">
          Remove Consultant <RiDeleteBin2Line className="menu-icon" /></Typography>
        </MenuItem>
      </Menu>
      <RemoveDialog />
      <Grid
        container
        columns={{xs: 1, sm: 1, md: 2, lg: 3, xl: 3}}
        spacing={5}
        className="salespersons-grid"
      >
        {filteredPersons.slice((page-1) * rows, (page-1) * rows + rows)
        .map(({Key, FirstName, LastName, ImgPath, InclusionStatus, City, State,  ZIP, Address1}) => (
          <Grid item key={Key}>
            <Card
              className="salespersons-profile"
            >
              <div className="card-content">
                <CardMedia className="salespersons-media">
                  <img src={ImgPath} className="salespersons-img"/>
                </CardMedia>
                <CardContent className="salespersons-content">
                  <div className="info">
                    <Typography className="salespersons-name" variant="caption">{FirstName + ' ' + LastName}</Typography>
                    <Typography className="salespersons-address" variant="caption">
                      {Address1}<br/>
                      {`${City}, ${State}, ${ZIP}`}
                    </Typography>
                    <Typography className="inclusion-status" variant="caption">
                      {InclusionStatus === 1 ?
                        <span className="included">INCLUDED</span>
                        : <span className="excluded">EXCLUDED</span>
                      }
                    </Typography>
                    {/* <Typography variant="caption" className="preview">View Preview</Typography> */}
                  </div>
                </CardContent>
              </div>
              <div className="btn">
                <Tooltip title="See More Options" placement="top">
                  <IconButton size="small" className="btn" onClick={(e) => handleOptionsOpen(e, Key)}><RiMore2Line /></IconButton>
                </Tooltip>
              </div>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Pagination
        page={page}
        onChange={handleChangePage}
        variant="outlined"
        count={Math.ceil(filteredPersons.length/rows)}
        classes={{ul: classes.pagination}}
        style={filteredPersons.length > 15 ? {} : {display: 'none'}}
      />
    </div>
  )
}
